"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/group/group-label-context.tsx
var _react = require('react');
var GroupLabelContext = _react.createContext.call(void 0, void 0);



exports.GroupLabelContext = GroupLabelContext;
